import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslocoService } from '@jsverse/transloco';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-samsung-browser-instructions-modal',
  templateUrl: './samsung-browser-instructions-modal.component.html',
  styleUrl: './samsung-browser-instructions-modal.component.scss'
})
export class SamsungBrowserInstructionsModalComponent {
  constructor(
    public modal: NgbActiveModal,
    private translocoService: TranslocoService,
    private sanitizer: DomSanitizer
  ) { }

  getSafeHtml(key: string): SafeHtml {
    const translation = this.translocoService.translate(key);
    return this.sanitizer.bypassSecurityTrustHtml(translation);
  }
}